import { useMemo } from 'react';

import { useShowBackerInfoForCause } from '@givebacks/api/backer';
import { useShowDonationItem } from '@givebacks/api/store';
import { ConditionalWrapper, Group, SelectableCard, Swipeable, Text, ThemeIcon, Title } from 'ui';
import { IconDelete } from 'ui/Icons';

import { centsToDollar } from '../../../utils';

type MyCauseCardProps = {
  isSmallScreen: boolean;
  title: string;
  src?: string;
  expires_at?: string;
  onClick?: ({ causeId, donationItemId }: { causeId: string; donationItemId: string }) => void;
  causeId: string;
  onSwipe?: () => void;
  enableSwipe?: boolean;
};

const MyCauseCard = ({
  isSmallScreen,
  title,
  src,
  onClick,
  causeId,
  onSwipe,
  enableSwipe = false,
}: MyCauseCardProps) => {
  const { data: backer } = useShowBackerInfoForCause({ causeId });
  const { data: donationItem } = useShowDonationItem({ storeId: causeId });

  const amountRaisedByBacker = useMemo(() => {
    return (
      <Group gap={4} align="center" wrap="nowrap">
        <Title order={4} c="mint">
          {centsToDollar(backer?.raised_by_backer ?? 0)}
        </Title>
        <Text fz="xs">raised by you</Text>
      </Group>
    );
  }, [backer]);

  return (
    <ConditionalWrapper
      condition={enableSwipe}
      wrapper={(children) => (
        <Swipeable
          rightAction={(props) => (
            <Swipeable.Action {...props} color="cerise" onSwipe={onSwipe}>
              <ThemeIcon variant="transparent" color="white">
                <IconDelete />
              </ThemeIcon>
            </Swipeable.Action>
          )}
        >
          {children}
        </Swipeable>
      )}
    >
      <SelectableCard
        title={title}
        imageSrc={src}
        stretchImage={false}
        isColumn={!isSmallScreen}
        description={isSmallScreen ? amountRaisedByBacker : undefined}
        detail={isSmallScreen ? undefined : amountRaisedByBacker}
        onClick={() => onClick?.({ causeId, donationItemId: donationItem?.uuid ?? '' })}
      />
    </ConditionalWrapper>
  );
};

export { MyCauseCard };
